import { defineStore } from 'pinia';
import { actions, getters, state } from '@/stores/methods';


export const useConversationsStore = defineStore('conversation', {
  state: state,
  getters: {
    sortedConversations(state) {
      return state.collection.sort((a, b) => {
        return b.last_updated_at > a.last_updated_at ? 1 : -1;
      });
    },
    unreadConversationsCount(state) {
      return (currentAgentId) => {
        let unreadCounter = 0;
        state.collection.forEach(c => {
          if (c.customer_messages_unread_count > 0 && (c.assigned_agent_id === currentAgentId || !c.assigned_agent_id)) {
            unreadCounter++;
          }
        });
        return unreadCounter;
      };
    },
    unreadConversationForStatus: (state) => {
      return (status, currentAgentId, exclude) => {
        let unreadCounter = 0;
        state.collection.forEach(c => {
          if (c.customer_messages_unread_count > 0) {
            if (c.status === status && !currentAgentId || c.status === status && currentAgentId && c.assigned_agent_id === currentAgentId && !exclude || c.status === status && currentAgentId && c.assigned_agent_id !== currentAgentId && exclude) {
              unreadCounter++;
            }
          }
        });
        return unreadCounter;
      };
    },
    groupConversationsCount: (state) => {
      return (groupId) => {
        let counter = 0;
        state.collection.forEach(c => {
          if (c.assigned_group_id === groupId) {
            counter++;
          }
        });
        return counter;
      };
    },
    getCustomerConversations: (state) => {
      return (customerId) => state.collection.find(c => c.customer.id === customerId);
    },
    getByCustomerId: (state) => {
      return (customerId) => {
        return state.collection.filter(c => {
          return c.customer_id === customerId;
        });
      };
    },
    ...getters,
  },
  actions: actions,
});
